import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export default function MinusCircleIcon(props: SvgIconProps): JSX.Element {
  return (
    <SvgIcon viewBox={'0 0 17.921 17.922'} fontSize={'inherit'} {...props}>
      <path
        id="Tracé_67"
        data-name="Tracé 67"
        d="M8.255,9.828s.012-.007,1.547,0h2.84a.735.735,0,0,0,.538-.225.753.753,0,0,0,.225-.554.749.749,0,0,0-.764-.768H9.8c-.662.009-.546,0-.766,0H5.3a.761.761,0,0,0-.559.224.744.744,0,0,0-.225.549.754.754,0,0,0,.219.553.765.765,0,0,0,.566.221Zm.7,8.093a8.657,8.657,0,0,1-3.482-.707,9.006,9.006,0,0,1-4.766-4.77A8.705,8.705,0,0,1,0,8.953,8.658,8.658,0,0,1,.708,5.468,9.13,9.13,0,0,1,2.636,2.617,9.018,9.018,0,0,1,5.483.7,8.717,8.717,0,0,1,8.958,0a8.818,8.818,0,0,1,3.494.7,8.914,8.914,0,0,1,2.853,1.917,9.042,9.042,0,0,1,1.915,2.858,8.8,8.8,0,0,1,.7,3.5,8.687,8.687,0,0,1-.7,3.477A8.98,8.98,0,0,1,15.3,15.281a9.2,9.2,0,0,1-2.857,1.928,8.656,8.656,0,0,1-3.493.712m.013-1.66a7.013,7.013,0,0,0,5.154-2.141,7.05,7.05,0,0,0,2.134-5.167A7.031,7.031,0,0,0,14.127,3.8a7.031,7.031,0,0,0-5.17-2.134A7.049,7.049,0,0,0,3.8,3.794,7.017,7.017,0,0,0,1.66,8.965,7.031,7.031,0,0,0,3.8,14.119a7.039,7.039,0,0,0,5.167,2.143"
        transform="translate(0 0)"
        fill="#333"
      />
    </SvgIcon>
  );
}
